import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { money, CURRENCIES } from "@/lib/api";
import { Panel } from "@/components/common";

const COLORS = { USD: "#4F46E5", GBP: "#0EA5E9", EUR: "#14B8A6", NGN: "#16A34A", KES: "#F59E0B", ZAR: "#EF4444", ZMW: "#A855F7" };

export function CurrencyMix({ mix = [], rc }) {
  const total = mix.reduce((s, x) => s + x.actual, 0);
  const data = mix.filter((x) => x.actual > 0);
  return (
    <Panel title={`Currency mix — actual spend to date (in ${rc})`} testid="currency-mix-panel">
      <div className="grid items-center gap-6 md:grid-cols-[260px_1fr]">
        <div className="h-56" data-testid="currency-mix-chart">
          {data.length ? (
            <ResponsiveContainer>
              <PieChart>
                <Pie data={data} dataKey="actual" nameKey="currency" innerRadius={55} outerRadius={95} paddingAngle={2}>
                  {data.map((x) => <Cell key={x.currency} fill={COLORS[x.currency] || "#94A3B8"} />)}
                </Pie>
                <Tooltip formatter={(v, n) => [money(v, rc), n]} />
              </PieChart>
            </ResponsiveContainer>
          ) : <div className="grid h-full place-items-center text-sm text-slate-500">No actual spend yet</div>}
        </div>
        <div className="min-w-0 overflow-x-auto"><table className="w-full min-w-[560px] text-sm" data-testid="currency-mix-table">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-500">
            <th className="py-2">Currency</th><th>Projects</th><th className="text-right">Spend (native)</th><th className="text-right">Spend ({rc})</th><th className="text-right">Share</th><th className="text-right">Budget ({rc})</th>
          </tr></thead>
          <tbody>
            {mix.map((x) => (
              <tr key={x.currency} className="border-t border-slate-100" data-testid={`currency-mix-row-${x.currency}`}>
                <td className="py-2"><span className="mr-2 inline-block h-2.5 w-2.5 rounded-full" style={{ background: COLORS[x.currency] }} />{x.currency} <span className="text-xs text-slate-500">{CURRENCIES[x.currency]?.[1]}</span></td>
                <td>{x.projects}</td>
                <td className="text-right font-mono text-xs">{money(x.actual_native, x.currency)}</td>
                <td className="text-right font-mono text-xs">{money(x.actual, rc)}</td>
                <td className="text-right font-mono text-xs" data-testid={`currency-mix-share-${x.currency}`}>{total ? `${Math.round((x.actual / total) * 100)}%` : "—"}</td>
                <td className="text-right font-mono text-xs">{money(x.budget, rc)}</td>
              </tr>
            ))}
          </tbody>
        </table></div>
      </div>
    </Panel>
  );
}
